import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/network/entry-logged-out/src/components/get-discovered/assets/discovered-background-small.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')